import React from 'react';
import PropTypes from 'prop-types';

const Images = ({ image }) => {

    const { largeImageURL, likes, previewURL, tags, views } = image;

    return (
        <div className="col-12 col-sm-6 col-md-4 col-lg-3">
            <div className="card">
                <img
                    src={previewURL} alt={tags} className="card-img-top"
                />
                <div className="card-body">
                    <p className="card-text ">{likes} Me gusta</p>
                    <p className="card-text ">{views} Vistas</p>
                </div>
                <div className="card-footer">
                    <a 
                        href={largeImageURL}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="btn btn-primary btn-block"
                    >
                        Ver Imagen
                    </a>
                </div>
            </div>
        </div>
    );
}

Images.proptTypes = {
    image: PropTypes.object.isRequired
}

export default Images;
